import { copyTextWithNotify } from "@/helpers/clipboard.helper.ts";
import { Button, LinkTo, ListItem, Stack, Title, useToasts } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface McpConnectionProps {
  url: string;
}

export const McpConnection = ({ url }: McpConnectionProps) => {
  const { t } = useTranslation();
  const { showInfo } = useToasts();

  const copyUrl = async () => {
    if (await copyTextWithNotify(url)) {
      showInfo({ title: t("common:copied") });
    }
  };

  return (
    <Stack className={"card-panel-sm"} gap={"2xl"}>
      <Title header={t("integrations:mcp_title")} caption={t("integrations:mcp_description")} />
      <ListItem
        title={url}
        valueSlot={
          <Button size={"sm"} variant={"secondary"} onClick={copyUrl}>
            {t("integrations:mcp_copy_address")}
          </Button>
        }
      />
      <LinkTo target={"_blank"} to={"/help/article/mcp-connection"}>
        {t("integrations:mcp_how_to_connect")}
      </LinkTo>
    </Stack>
  );
};
